import { convertDigitToProperFormat } from '../../../../utils/number';
import { ApproveState } from '../../../../store/pdp/types';

export const messages = {
  lastUpdate: 'اخرین بروز رسانی',
  creationDate: 'جدیدترین ایجاد',
  updateDate: 'جدیدترین بروزرسانی',
  classMember: 'عضو دوره',
  title: 'عنوان سال‌ آموزشی',
  relatedRoles: 'گروه هدف',
  action: 'عملیات',
  Request: 'درخواست',
  addTopic: 'افزودن سرفصل آموزشی',
  nameCantBeEmpty: 'عنوان نمی‌تواند خالی باشد',
  termPhases: 'مراحل تکمیل /تایید نیاز آموزشی',
  addPhase: 'افزودن مرحله',
  save: 'ذخیره',
  selectAMember: 'یک فرد را انتخاب کنید ',
  addProgram: 'افزودن نیازسنجی',
  phaseTitle: 'عنوان مرحله',
  startDate: 'تاریخ شروع:',
  endDate: 'تاریخ پایان:',
  whoManageWhom: 'قوانین تکمیل / تایید نیازسنجی در این مرحله',
  respectDistrict: 'در نظر گرفتن بخش',
  topicLimits: 'محدودیت عناوین آموزشی',
  addLimit: 'افزودن محدودیت',
  relatedTag: 'برچسب مرتبط',
  selectAll: 'انتخاب همه سرفصل‌های مرتبط',
  minCount: 'حداقل تعداد',
  maxCount: 'حداکثر تعداد',
  noLimit: 'بدون محدودیت',
  managerRole: 'سمت مدیریت کننده',
  targetRoles: 'سمت های مدیریت شونده',
  termNotFound: 'برنامه توسعه فردی یافت نشد',
  errorLoadingData: 'خطا در دریافت داده‌ها',
  approve: 'تایید',
  New: 'جدید',
  Approved: 'تایید شده',
  Rejected: 'رد شده',
  Unknown: 'در انتظار تایید',
  cancel: 'لغو',
  currentPhase: 'فاز فعال',
  phaseDuration: 'محدودیت زمانی فاز',
  topicIsNotRelatedToUser: 'این سرفصل به سمت کاربر مرتبط نیست',
  missingRequiredTopic: 'انتخاب این سرفصل‌ها الزامی است',
  comma: '،',
  addAll: 'افزودن',
  requestNewTopic: 'درخواست سرفصل جدید',
  propesedWarningExtra: 'سرفصل پس از تایید نهایی مسئول آموزش اضافه می‌شود.',
  propesedWarning:
    'درخواست ایجاد این سرفصل آموزشی ایجاد شده است اما هنوز تایید نشده است',
  noSelected: 'عدم انتخاب گزینه',
  rejectedTopicsAreNotIncluded: 'افراد رد شده در آمار در نظر گرفته نشده‌اند',
  allEditableInPhase: 'قابل ویرایش در این فاز',
  allVisible: 'قابل مشاهده توسط من',
  filterPDP: 'فیلتر نمایش نیازسنجی‌ها',
  filterDistrict: 'فیلتر بخش',
  filterPost: 'فیلتر سمت',
  orderBy: 'مرتب سازی',
  alphabetic: 'الفبا',
  approvedCount: 'بیشترین تایید شده',
  requestCount: 'بیشترین درخواست شده',
  suggestCount: 'بیشترین پیشنهاد افزودن',
  waitingCount: 'بیشترین در انتظار تایید',
  phaseHint: 'راهنمای فاز',
  understood: 'متوجه شدم',
  filter: 'فیلتر',
  pdpSaved: 'نیاز سنجی ذخیره شد',
  batchAddHint:
    'جهت افزودن/تایید سرفصل آموزشی برای یک گروه خاص،  سرفصل مورد نظر را مشخص کنید و یا با نوشتن سرفصل پیشنهادی جدید آن را برای گروه هدف درخواست دهید',
  searchName: 'جستجوی فرد',
  defindClassTemplate: 'ساختار پایه دوره را تعریف کنید',
  viewClass: 'نمایش دوره',
  addAllUsersToClass: 'افزودن همه به دوره ',
  createNewClass: 'ساخت دوره جدید',
  pleaseSpecifyPhases: 'مراحل نیاز سنجی را در بخش ویرایش مشخص کنید',
  mandatory: 'الزامی',
  roles: 'سمت‌ها',
  overview: 'خلاصه نیازسنجی کاربر',
  myProgram: 'نیازسنجی من',
  myManagingProgram: 'نیازسنجی افراد تحت مدیریت',
  requestNewTopicChoice: '+ درخواست سرفصل جدید',
  enterTopicName: 'سرفصل مورد نظر خود رو وارد کنید',
  pleaseEnterTopicName:
    'در صورتی که سرفصل مورد نظر خود را در بین موارد موجود نیافته اید آن را وارد کنید تا پس از تایید مسئول آموزش به لیست سرفصل‌ها اضافه شود',
  considerLimits: 'به محدودیت‌های زیر توجه کنید',
  gotIt: 'متوجه شدم',
  topic: 'سرفصل',
  topics: 'سرفصل‌های',
  topicsTab: 'سرفصل‌ها',
  personsTab: 'افراد',
  role: 'سمت',
  userCount: 'تعداد کاربران',
  actionsForRequested: 'تایید / رد درخواست',
  actionsForAllTarget: 'کل گروه هدف',
  actions: 'عملیات',
  addAllTargetGroup: 'افزودن همه گروه هدف',
  approveAllRequested: 'تایید همه درخواست‌ها',
  set: 'ثبت',
  changesNotSaved: 'تغییرات ذخیره نشده اند. ایا مطمئن هستید؟',
  hideReportPart: 'پنهان کردن گزارش‌ها',
  delete: 'حذف',
  pdpRemoved: 'نیازسنجی حذف شد',
  done: 'انجام شد',
  disabled: 'غیر فعال',
  deleted: 'حذف شده',
  searchTopic: 'جستجوی سرفصل',
  back: 'بازگشت',
  pleaseSpecifyTopicDetails: 'لطفا جزئیات سرفصل را مشخص کنید',
  topicAddedSelectNextTopic: 'سرفصل اضافه شد لطفا سرفصل بعدی را انتخاب کنید',
  selectedTopics: 'لیست سرفصل‌های انتخاب شده',
  empty: 'موردی یافت نشد',
  notFound: 'موردی یافت نشد',
  actionDots: '...',
  persons: 'نفر',
  from: 'از',
  deleteThisTopic: 'آیا از حذف این سرفصل برای همه مطمئن هستید؟',
  pdpHasWarn: 'نیازمند توجه،  برای اطلاعات بیشتر کلیک کنید',
  pdpWithError:
    'اشکالاتی در این نیاز سنجی وجود دارد برای اطلاعات بیشتر کلیک کنید',

  stats(name: string) {
    return `آمار نیازسنجی سرفصل ${name} `;
  },

  changeAllTo: (v: string) => `تغییر «${v}» برای همه تایید شده‌ها`,

  addAllMissingProgram: (count: number) => {
    return `ایجاد نیاز سنجی آموزشی برای ${convertDigitToProperFormat(count)} فرد باقیمانده`;
  },
  missingProgram: (count: number) => {
    return `  ${convertDigitToProperFormat(count)} فرد هنوز نیازسنجی خود را انجام نداده اند`;
  },
  addMyProgram: 'ثبت نیاز آموزشی من',
  selectATopic: 'سرفصل آموزشی',
  batchAdd: 'افزودن تجمیعی',
  selectATargetRole: 'گروه کاربران / سمت',
  allUsers: 'همه کاربران',
  approved: 'تایید شده',
  approveAll: 'تایید همه',
  approveAllWaiting: 'تایید همه درخواست‌های در انتظار تایید',
  rejected: 'رد شده',
  unknown: 'در انتظار تایید',
  previousRejected: 'رد شده در مراحل قبل',
  mandatoryUsers: 'گروه هدف (الزامی)',
  optionalUsers: 'گروه هدف (اختیاری)',
  notRelatedUsers: 'کاربران غیر مرتبط',
  topicStats: 'آمار سرفصل‌های آموزشی',
  reject: 'رد',
  rejectAll: 'رد‌ همه',
  rejectAllWaiting: 'رد‌ همه درخواست‌های در انتظار تایید',
  rejectAllRequested: 'رد‌ همه درخواست‌ها',
  areYouSure: 'آیا از اعمال تغییرات مطمن هستید؟',
  newTopics(count: number) {
    return `${convertDigitToProperFormat(count)} سرفصل پیشنهادی`;
  },
  batchAddTo(batchAddCount: number) {
    return `افزودن یا تایید ${convertDigitToProperFormat(batchAddCount)} فرد`;
  },
  batchAddMessage(batchAddUserIds: number, name: string) {
    return `سرفصل «${name}» برای ${convertDigitToProperFormat(batchAddUserIds)} نفر اضافه یا تایید خواهد شد`;
  },
  batchAddSuccessful(
    length: number,
    name: string,
    type: ApproveState | 'delete' = 'Approved'
  ) {
    return ` «${name}» برای ${convertDigitToProperFormat(length)} نفر ${
      type === 'Approved' ? 'تایید' : type === 'delete' ? 'حذف' : 'رد'
    } شد`;
  },
  actionByUserInPhase(action: string, phase: string | undefined, name: string) {
    return `${action} شده توسط «${name}» در مرحله «${phase}»`;
  },
  fewTopicOfTypeSelected(
    parentTagName: string,
    tagName: string,
    count: number
  ) {
    return `حداقل ${convertDigitToProperFormat(count)} سرفصل با ${parentTagName} ${tagName} انتخاب کنید `;
  },
  pleaseSelectAllTopicsWith(parentTagName: string, tagName: string) {
    return `تمام سرفصل با ${parentTagName} ${tagName} را انتخاب کنید `;
  },
  extraTopicOfTypeSelected(
    parentTagName: string,
    tagName: string,
    count: number
  ) {
    return `حداکثر ${convertDigitToProperFormat(count)} سرفصل با ${parentTagName} ${tagName} انتخاب کنید `;
  },
  boundTopicOfTypeSelected(
    parentTagName: string,
    tagName: string,
    min: number,
    max: number
  ) {
    return `حذاقل ${convertDigitToProperFormat(min)}و حداکثر ${convertDigitToProperFormat(max)} سرفصل با ${parentTagName} ${tagName} انتخاب کنید `;
  },
  addMissingProgram: 'ایجاد',
  createClass(name: string) {
    return `ساخت دوره ${name}`;
  },
  usersAddedToClass(foundUsers: string, topic: string) {
    return `${foundUsers} به دوره ${topic} اضافه شدند`;
  },
  classNowSupportsMembersOfProgram(name: string, termName: string) {
    return `دوره ${name} هم‌اکنون از افراد گروه هدف ${termName} نیز پشتیبانی می‌کند`;
  },
  useClassSharedWith(groupNames: string[]) {
    return `استفاده از دوره مشترک با ${groupNames.join(', ')}`;
  },
  pleaseSelectAtLeast(min: number) {
    return `حداقل ${convertDigitToProperFormat(min)} سرفصل انتخاب کنید`;
  },
  pleaseSelectAtLeastAndAtMost(min: number, max: number) {
    return `حداقل ${convertDigitToProperFormat(min)} و حداکثر ${convertDigitToProperFormat(max)} سرفصل انتخاب کنید`;
  },
  pleaseSelectAtMost(max: number) {
    return `حداکثر ${convertDigitToProperFormat(max)} سرفصل انتخاب کنید`;
  },
  acceptTopic(name: string) {
    return `تایید سرفصل ${name}`;
  },
  selected(count: number) {
    return `(${convertDigitToProperFormat(count)} مورد انتخاب شده)`;
  },
  termsEn(count: string) {
    return `${count} مورد`;
  },
  added: 'مباحث درخواست شده',
  confirmDeletePDP(name: string) {
    return `آیا از حذف نیازسنجی آموزشی «${name}» مطمئن هستید. این کار غیر قابل برگشت است.`;
  },
  programsReport: 'گزارش برنامه‌های آموزشی',
  employeeId: 'کد پرسنلی',
  report(name: string, year: string, type: string) {
    return `${type}_${name}_${year}`;
  },
  excelExport: 'خروجی اکسل',
  name: 'نام',
  rejectedBy: (name: string, phase: string) =>
    `رد درخواست توسط ${name} در مرحله ${phase}`,
};
